import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import {
  toString1pkumu07cwy4m as toString,
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  hashCodeq5arwsb9dgti as hashCode,
  protoOf180f3jzyo7rfj as protoOf,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instancev9v8hjid95df as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  checkNameIsNotAPrimitive28vmhppr4nskt as checkNameIsNotAPrimitive,
  PrimitiveDescriptorSafe1r3pht5v1oaqu as PrimitiveDescriptorSafe,
} from '../internal/Primitives.mjs';
import {
  PrimitiveKindndgbuh6is7ze as PrimitiveKind,
  CLASS_getInstance25nhr3t715wdo as CLASS_getInstance,
} from './SerialKinds.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  toList383f556t1dixk as toList,
  withIndex3s8q7w1g0hyfn as withIndex,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Arrays.mjs';
import { emptyList1g2z5xcrvp2zy as emptyList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import { HashSet2dzve9y63nf0v as HashSet } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/HashSet.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import {
  toStringImpl1y3u8fza7vdq as toStringImpl,
  hashCodeImplfv8qiy3re24s as hashCodeImpl,
} from '../internal/PluginGeneratedSerialDescriptor.mjs';
import {
  SerialDescriptor2pelqekb5ic3a as SerialDescriptor,
  get_isNullable36pbikm8xb7bz as get_isNullable,
  get_isInline5x26qrhi9qs6 as get_isInline,
} from './SerialDescriptor.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import {
  toHashSet1qrcsl3g8ugc8 as toHashSet,
  toBooleanArray2u3qw7fjwsmuh as toBooleanArray,
} from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_Collections.mjs';
import { copyToArray2j022khrow2yi as copyToArray } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { compactArray1b2nl9rkq8nuz as compactArray } from '../internal/Platform.common.mjs';
import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { toMap1vec9topfei08 as toMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  getChecked1o70dkx10jwym as getChecked,
  getChecked3avs2psuwt1xd as getChecked_0,
} from '../internal/Platform.mjs';
import { contentEqualsaf55p28mnw74 as contentEquals } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import { CachedNames2minxlyafeo07 as CachedNames } from '../internal/CachedNames.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function SerialDescriptor_0(serialName, original) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!(serialName === original.d1o())) {
    var message_0 = 'The name of the wrapped descriptor (' + serialName + ') cannot be the same as the name of the original descriptor (' + original.d1o() + ')';
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var tmp = original.w1p();
  if (tmp instanceof PrimitiveKind()) {
    checkNameIsNotAPrimitive(serialName);
  }
  return new (WrappedSerialDescriptor())(serialName, original);
}
function PrimitiveSerialDescriptor(serialName, kind) {
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  return PrimitiveDescriptorSafe(serialName, kind);
}
function buildClassSerialDescriptor(serialName, typeParameters, builderAction) {
  var tmp;
  if (builderAction === VOID) {
    tmp = buildClassSerialDescriptor$lambda;
  } else {
    tmp = builderAction;
  }
  builderAction = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builderAction(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, CLASS_getInstance(), sdBuilder.o1n_1.q2(), toList(typeParameters), sdBuilder);
}
var ClassSerialDescriptorBuilderClass;
function ClassSerialDescriptorBuilder() {
  if (ClassSerialDescriptorBuilderClass === VOID) {
    class $ {
      constructor(serialName) {
        this.l1n_1 = serialName;
        this.m1n_1 = false;
        this.n1n_1 = emptyList();
        this.o1n_1 = ArrayList().p2();
        this.p1n_1 = HashSet().ga();
        this.q1n_1 = ArrayList().p2();
        this.r1n_1 = ArrayList().p2();
        this.s1n_1 = ArrayList().p2();
      }
      l1q(elementName, descriptor, annotations, isOptional) {
        // Inline function 'kotlin.require' call
        if (!this.p1n_1.i2(elementName)) {
          var message = "Element with name '" + elementName + "' is already registered in " + this.l1n_1;
          throw IllegalArgumentException().n2(toString(message));
        }
        // Inline function 'kotlin.collections.plusAssign' call
        this.o1n_1.i2(elementName);
        // Inline function 'kotlin.collections.plusAssign' call
        this.q1n_1.i2(descriptor);
        // Inline function 'kotlin.collections.plusAssign' call
        this.r1n_1.i2(annotations);
        // Inline function 'kotlin.collections.plusAssign' call
        this.s1n_1.i2(isOptional);
      }
      t1n(elementName, descriptor, annotations, isOptional, $super) {
        annotations = annotations === VOID ? emptyList() : annotations;
        isOptional = isOptional === VOID ? false : isOptional;
        var tmp;
        if ($super === VOID) {
          this.l1q(elementName, descriptor, annotations, isOptional);
          tmp = Unit_instance;
        } else {
          tmp = $super.l1q.call(this, elementName, descriptor, annotations, isOptional);
        }
        return tmp;
      }
    }
    initMetadataForClass($, 'ClassSerialDescriptorBuilder');
    ClassSerialDescriptorBuilderClass = $;
  }
  return ClassSerialDescriptorBuilderClass;
}
function buildSerialDescriptor(serialName, kind, typeParameters, builder) {
  var tmp;
  if (builder === VOID) {
    tmp = buildSerialDescriptor$lambda;
  } else {
    tmp = builder;
  }
  builder = tmp;
  // Inline function 'kotlin.text.isNotBlank' call
  // Inline function 'kotlin.require' call
  if (!!isBlank(serialName)) {
    var message = 'Blank serial names are prohibited';
    throw IllegalArgumentException().n2(toString(message));
  }
  // Inline function 'kotlin.require' call
  if (!!equals(kind, CLASS_getInstance())) {
    var message_0 = "For StructureKind.CLASS please use 'buildClassSerialDescriptor' instead";
    throw IllegalArgumentException().n2(toString(message_0));
  }
  var sdBuilder = new (ClassSerialDescriptorBuilder())(serialName);
  builder(sdBuilder);
  return new (SerialDescriptorImpl())(serialName, kind, sdBuilder.o1n_1.q2(), toList(typeParameters), sdBuilder);
}
var WrappedSerialDescriptorClass;
function WrappedSerialDescriptor() {
  if (WrappedSerialDescriptorClass === VOID) {
    class $ {
      constructor(serialName, original) {
        this.m1q_1 = serialName;
        this.n1q_1 = original;
      }
      d1o() {
        return this.m1q_1;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof WrappedSerialDescriptor()))
          return false;
        return this.m1q_1 === other.m1q_1 && equals(this.n1q_1, other.n1q_1);
      }
      hashCode() {
        var result = getStringHashCode(this.m1q_1);
        result = imul(31, result) + hashCode(this.n1q_1) | 0;
        return result;
      }
      toString() {
        return toStringImpl(this);
      }
      w1p() {
        return this.n1q_1.w1p();
      }
      p1p() {
        return this.n1q_1.p1p();
      }
      x1p() {
        return this.n1q_1.x1p();
      }
      y1p() {
        return this.n1q_1.y1p();
      }
      z1p() {
        return this.n1q_1.z1p();
      }
      a1q(index) {
        return this.n1q_1.a1q(index);
      }
      b1q(name) {
        return this.n1q_1.b1q(name);
      }
      c1q(index) {
        return this.n1q_1.c1q(index);
      }
      d1q(index) {
        return this.n1q_1.d1q(index);
      }
      e1q(index) {
        return this.n1q_1.e1q(index);
      }
    }
    initMetadataForClass($, 'WrappedSerialDescriptor', VOID, VOID, [SerialDescriptor()]);
    WrappedSerialDescriptorClass = $;
  }
  return WrappedSerialDescriptorClass;
}
function _get__hashCode__tgwhef($this) {
  var tmp0 = $this.z1q_1;
  var tmp = KProperty1();
  // Inline function 'kotlin.getValue' call
  getPropertyCallableRef('_hashCode', 1, tmp, SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp(), null);
  return tmp0.n3();
}
function SerialDescriptorImpl$_get__hashCode_$ref_2v7wzp() {
  return (p0) => _get__hashCode__tgwhef(p0);
}
var SerialDescriptorImplClass;
function SerialDescriptorImpl() {
  if (SerialDescriptorImplClass === VOID) {
    class $ {
      constructor(serialName, kind, elementsCount, typeParameters, builder) {
        this.o1q_1 = serialName;
        this.p1q_1 = kind;
        this.q1q_1 = elementsCount;
        this.r1q_1 = builder.n1n_1;
        this.s1q_1 = toHashSet(builder.o1n_1);
        var tmp = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_0 = builder.o1n_1;
        tmp.t1q_1 = copyToArray(this_0);
        this.u1q_1 = compactArray(builder.q1n_1);
        var tmp_0 = this;
        // Inline function 'kotlin.collections.toTypedArray' call
        var this_1 = builder.r1n_1;
        tmp_0.v1q_1 = copyToArray(this_1);
        this.w1q_1 = toBooleanArray(builder.s1n_1);
        var tmp_1 = this;
        // Inline function 'kotlin.collections.map' call
        var this_2 = withIndex(this.t1q_1);
        // Inline function 'kotlin.collections.mapTo' call
        var destination = ArrayList().h2(collectionSizeOrDefault(this_2, 10));
        var _iterator__ex2g4s = this_2.p1();
        while (_iterator__ex2g4s.q1()) {
          var item = _iterator__ex2g4s.r1();
          var tmp$ret$4 = to(item.fk_1, item.ek_1);
          destination.i2(tmp$ret$4);
        }
        tmp_1.x1q_1 = toMap(destination);
        this.y1q_1 = compactArray(typeParameters);
        var tmp_2 = this;
        tmp_2.z1q_1 = lazy(() => hashCodeImpl(this, this.y1q_1));
      }
      d1o() {
        return this.o1q_1;
      }
      w1p() {
        return this.p1q_1;
      }
      y1p() {
        return this.q1q_1;
      }
      z1p() {
        return this.r1q_1;
      }
      a1r() {
        return this.s1q_1;
      }
      a1q(index) {
        return getChecked(this.t1q_1, index);
      }
      b1q(name) {
        var tmp0_elvis_lhs = this.x1q_1.u4(name);
        return tmp0_elvis_lhs == null ? -3 : tmp0_elvis_lhs;
      }
      c1q(index) {
        return getChecked(this.v1q_1, index);
      }
      d1q(index) {
        return getChecked(this.u1q_1, index);
      }
      e1q(index) {
        return getChecked_0(this.w1q_1, index);
      }
      equals(other) {
        var tmp$ret$0;
        $l$block_5: {
          // Inline function 'kotlinx.serialization.internal.equalsImpl' call
          if (this === other) {
            tmp$ret$0 = true;
            break $l$block_5;
          }
          if (!(other instanceof SerialDescriptorImpl())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.d1o() === other.d1o())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!contentEquals(this.y1q_1, other.y1q_1)) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          if (!(this.y1p() === other.y1p())) {
            tmp$ret$0 = false;
            break $l$block_5;
          }
          var inductionVariable = 0;
          var last = this.y1p();
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              if (!(this.d1q(index).d1o() === other.d1q(index).d1o())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
              if (!equals(this.d1q(index).w1p(), other.d1q(index).w1p())) {
                tmp$ret$0 = false;
                break $l$block_5;
              }
            }
             while (inductionVariable < last);
          tmp$ret$0 = true;
        }
        return tmp$ret$0;
      }
      hashCode() {
        return _get__hashCode__tgwhef(this);
      }
      toString() {
        return toStringImpl(this);
      }
    }
    protoOf($).p1p = get_isNullable;
    protoOf($).x1p = get_isInline;
    initMetadataForClass($, 'SerialDescriptorImpl', VOID, VOID, [SerialDescriptor(), CachedNames()]);
    SerialDescriptorImplClass = $;
  }
  return SerialDescriptorImplClass;
}
function buildClassSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
function buildSerialDescriptor$lambda(_this__u8e3s4) {
  return Unit_instance;
}
//region block: exports
export {
  PrimitiveSerialDescriptor as PrimitiveSerialDescriptor3egfp53lutxj2,
  SerialDescriptor_0 as SerialDescriptorbzxbhtn690r4,
  buildClassSerialDescriptor as buildClassSerialDescriptors2a6xdp6mrtw,
  buildSerialDescriptor as buildSerialDescriptor2873qmkp8r2ib,
};
//endregion

//# sourceMappingURL=SerialDescriptors.mjs.map
